import { IApplicationState } from '../../types/redux';

export const selectFolders = (state: IApplicationState) => state.folders.list;
